import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class UserRequest extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.CURRENT_USER);
    }

}



// WEBPACK FOOTER //
// ./src/app/login/ws/UserRequest.js